import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      <div className="bg-card rounded-xl p-6 border border-border">
        <div className="flex items-center justify-between mb-2">
          <Icon name="Target" size={24} className="text-primary" />
          <span className="text-2xl font-bold text-foreground">{stats?.totalAttempts}</span>
        </div>
        <p className="text-sm text-muted-foreground">Total Attempts</p>
      </div>
      <div className="bg-card rounded-xl p-6 border border-border">
        <div className="flex items-center justify-between mb-2">
          <Icon name="TrendingUp" size={24} className="text-success" />
          <span className="text-2xl font-bold text-success">{stats?.successRate}%</span>
        </div>
        <p className="text-sm text-muted-foreground">Success Rate</p>
      </div>
      <div className="bg-card rounded-xl p-6 border border-border">
        <div className="flex items-center justify-between mb-2">
          <Icon name="Award" size={24} className="text-accent" />
          <span className="text-2xl font-bold text-foreground">{stats?.masteredObjections}</span>
        </div>
        <p className="text-sm text-muted-foreground">Mastered</p>
      </div>
      <div className="bg-card rounded-xl p-6 border border-border">
        <div className="flex items-center justify-between mb-2">
          <Icon name="Bookmark" size={24} className="text-warning" />
          <span className="text-2xl font-bold text-foreground">{stats?.bookmarked}</span>
        </div>
        <p className="text-sm text-muted-foreground">Bookmarked</p>
      </div>
    </div>
  );
};

export default StatsOverview;